import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { addMonths } from 'date-fns';
import type { Contract } from '../entities/Contract.js';
import { Probezeit } from '../enums/Probezeit.js';

/**
 * Calculates the end of the trial period based on the contract's information.
 * @param contract
 * @returns Date | null The date when the trial period ends or null if null if the trial period is not defined.
 */
export function calculateEndOfTrialTime(
  contract: NarrowedEntity<Contract, { agInfos: { dauerProbezeit: 1; einstellungsdatum: 1 } }>,
): Date | null {
  if (contract.agInfos?.dauerProbezeit === Probezeit.HALBJAHR) {
    const beginn = contract.agInfos.einstellungsdatum;
    if (!beginn) return null;
    return addMonths(beginn, 6);
  }
  return null;
}
